import React, { useEffect, useState } from 'react';
import CalendarIcon from '../../../assets/icons/calendar.svg';
import AccountIcon from '../../../assets/icons/card-account-details-outline.svg';
import EditIcon from '../../../assets/icons/edit.svg';
import PhoneIcon from '../../../assets/icons/phone-in-talk.svg';
import WhatsappIcon from '../../../assets/icons/whatsapp.svg';
import ScreenLoader from '../../../components/common/ScreenLoader';
import { useLocation } from 'react-router';
import AddressDetails from '../../../components/common/modals/edit_details/address_details';
import CardDetails from '../../../components/common/modals/edit_details/card_details';
import EducationDetails from '../../../components/common/modals/edit_details/education_details';
import GuardianDetails from '../../../components/common/modals/edit_details/guardian_details';
import GuardianImage from '../../../components/common/modals/edit_details/guardian_image';
import EditPersonalDetails from '../../../components/common/modals/edit_details/personal_details';
import ProfileImage from '../../../components/common/modals/edit_details/profile_image';
import { AuthenticatedGETRequest } from '../../../utils';

const StudentDetails = ({ createNotification }) => {
    const { search } = useLocation();
    const [student, setStudent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [edit_profile_image, setEditPersonalImage] = useState(false);
    const [edit_personal_details, setEditPersonalDetails] = useState(false);
    const [edit_address_details, setEditAddressDetails] = useState(false);
    const [edit_education_details, setEditEducationDetails] = useState(false);
    const [edit_guardian_image, setEditGuardianImage] = useState(false);
    const [edit_guardian_details, setEditGuardianDetails] = useState(false);
    const [edit_card_details, setEditCardDetails] = useState(false);
    const [onImageHover, setOnImageHover] = useState(false);

    useEffect(() => {
        setLoading(true);
        const fetchStudent = async (applicantId) => {
            const { data, success } = await AuthenticatedGETRequest(
                `students/${applicantId}`,
            );
            setLoading(false);
            if (success) {
                setStudent(data);
            } else {
                createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
            }
        };
        fetchStudent(search.replace('?id=', ''));
    }, [createNotification, search]);

    return loading ? (
        <ScreenLoader />
    ) : (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            {/* Personal information */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '12px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>ذاتی معلومات</h2>

                    <div
                        className='flex alignCenter pointer'
                        onClick={() => setEditPersonalDetails(true)}
                    >
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>

                <div
                    className='flex justifyBetween alignStart w-100'
                    style={{
                        background: '#ffffff',
                        padding: '12px 24px 6px',
                        minHeight: 120,
                    }}
                >
                    <div className='flex justifyStart'>
                        <div
                            className='flex'
                            style={{ position: 'relative' }}
                            onMouseEnter={() => setOnImageHover(true)}
                            onMouseLeave={() => setOnImageHover(false)}
                        >
                            <img
                                src={student.image_url}
                                alt='profile_image'
                                height={120}
                                width={120}
                                style={{ borderRadius: '50%', border: '1px solid #757575' }}
                            />
                            {onImageHover && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        width: 120,
                                        height: 120,
                                        background: '#00000075',
                                        borderRadius: '50%',
                                    }}
                                >
                                    <div
                                        className='flex justifyCenter alignCenter pointer h-100'
                                        onClick={() => setEditPersonalImage(true)}
                                    >
                                        <img
                                            src={EditIcon}
                                            alt='edit_icon'
                                            height={24}
                                            width={24}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='flex column' style={{ marginRight: 16 }}>
                            <div className='flex alignCenter' style={{ marginTop: 8 }}>
                                <h2 style={{ color: '#000000' }}> {student.name}</h2>
                            </div>
                            <div className='flex alignCenter' style={{ marginTop: 4 }}>
                                <div className='flex alignCenter'>
                                    <h4 style={{ color: '#000000', marginLeft: 12 }}>
                                        تاریخ پیدائش:
                                    </h4>
                                    <img
                                        src={CalendarIcon}
                                        alt='تاریخ پیدائش'
                                        height={16}
                                        width={16}
                                        style={{ objectFit: 'contain' }}
                                    />
                                    <h5
                                        style={{
                                            color: '#000000',
                                            marginRight: 12,
                                            fontFamily: 'CircularStd',
                                        }}
                                    >
                                        {student.date_of_birth}
                                    </h5>
                                </div>
                                <div
                                    style={{
                                        background: '#42424294',
                                        height: 16,
                                        width: 2,
                                        margin: '0 8px',
                                    }}
                                />
                                <div className='flex alignCenter'>
                                    <h4 style={{ color: '#000000', marginLeft: 14 }}>
                                        داخلہ کی تاریخ:
                                    </h4>
                                    <img
                                        src={CalendarIcon}
                                        alt='داخلہ کی تاریخ'
                                        height={16}
                                        width={16}
                                        style={{ objectFit: 'contain' }}
                                    />
                                    <h5
                                        style={{
                                            color: '#000000',
                                            marginRight: 12,
                                            fontFamily: 'CircularStd',
                                        }}
                                    >
                                        {student.date_of_admission}
                                    </h5>
                                </div>
                            </div>

                            <div className='flex alignCenter' style={{ marginTop: 4 }}>
                                <div className='flex alignCenter'>
                                    <h4 style={{ color: '#000000', marginLeft: 10 }}>
                                        شناختی کارڈ نمبر:
                                    </h4>
                                    <img
                                        src={AccountIcon}
                                        alt='شناختی کارڈ نمبر'
                                        height={16}
                                        width={16}
                                        style={{ objectFit: 'contain' }}
                                    />
                                    <h5
                                        style={{
                                            color: '#000000',
                                            marginRight: 12,
                                            fontFamily: 'CircularStd',
                                        }}
                                    >
                                        {student.cnic}
                                    </h5>
                                </div>
                                <div
                                    style={{
                                        background: '#42424294',
                                        height: 16,
                                        width: 2,
                                        margin: '0 8px',
                                    }}
                                />
                                <div className='flex alignCenter'>
                                    <h4 style={{ color: '#000000' }}>رجسڑیشن نمبر : </h4>
                                    <h5 style={{ color: '#000000', marginRight: 8 }}>
                                        {student.registration_id}
                                    </h5>
                                </div>
                            </div>

                            <div className='flex alignCenter' style={{ marginTop: 4 }}>
                                <div className='flex alignCenter'>
                                    <h4 style={{ color: '#000000' }}>بلڈ گروپ : </h4>
                                    <h5
                                        style={{
                                            color: '#000000',
                                            marginRight: 8,
                                            direction: 'ltr',
                                        }}
                                    >
                                        {student.blood_group || 'معلوم نہیں'}
                                    </h5>
                                </div>
                                <div
                                    style={{
                                        background: '#42424294',
                                        height: 16,
                                        width: 2,
                                        margin: '0 16px',
                                    }}
                                />
                                <div className='flex alignCenter'>
                                    <h4 style={{ color: '#000000' }}>کلاس گروپ : </h4>
                                    <h5 style={{ color: '#000000', marginRight: 8 }}>
                                        {student.section
                                            ? student.section.name.urdu
                                            : 'ابھی گروپ منتغب نہیں کیا گیا'}
                                    </h5>
                                </div>
                            </div>

                            <div className='flex alignCenter' style={{ marginTop: 4 }}>
                                <div className='flex alignCenter'>
                                    <h4 style={{ color: '#000000' }}>برانچ کا نام : </h4>
                                    <h5
                                        style={{
                                            color: '#fff',
                                            fontSize: 16,
                                            background: '#4caf50',
                                            padding: '4px 16px 0',
                                            borderRadius: 4,
                                            marginRight: 8,
                                        }}
                                    >
                                        {student.branch && student.branch.name.urdu}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className='flex column'
                        style={{
                            background: '#ECFAF6',
                            borderRadius: 4,
                            marginTop: 8,
                            border: '1px solid #058464',
                            minWidth: 300,
                            padding: '12px 16px 10px',
                        }}
                    >
                        <h3 style={{ color: '#000000' }}>رابطے کی معلومات </h3>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <div className='flex alignCenter'>
                                <img
                                    src={WhatsappIcon}
                                    alt='موبائل نمبر'
                                    height={16}
                                    width={16}
                                    style={{ objectFit: 'contain' }}
                                />
                                <h5
                                    style={{
                                        color: '#000000',
                                        marginRight: 12,
                                        fontFamily: 'CircularStd',
                                    }}
                                >
                                    {student.primary_phone_number}
                                </h5>
                            </div>
                            {student.secondary_phone_number && (
                                <div
                                    style={{
                                        background: '#42424294',
                                        height: 16,
                                        width: 2,
                                        margin: '0 8px',
                                    }}
                                />
                            )}
                            {student.secondary_phone_number && (
                                <div className='flex alignCenter'>
                                    <img
                                        src={PhoneIcon}
                                        alt='موبائل نمبر'
                                        height={16}
                                        width={16}
                                        style={{ objectFit: 'contain' }}
                                    />
                                    <h5
                                        style={{
                                            color: '#000000',
                                            marginRight: 8,
                                            fontFamily: 'CircularStd',
                                        }}
                                    >
                                        {student.secondary_phone_number}
                                    </h5>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#eeeded',
                        padding: '14px 24px 6px',
                        borderTop: '1px solid #757575',
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div className='flex alignCenter'>
                        <h3 style={{ color: '#757575' }}>والد کا نام: </h3>
                        <h3 style={{ color: '#757575', marginRight: 12 }}>
                            {student.father_name}
                        </h3>
                    </div>

                    <div className='flex alignCenter'>
                        <h3 style={{ color: '#757575' }}>والد کا شناختی کارڈ نمبر: </h3>
                        <h5 style={{ color: '#757575', marginRight: 12 }}>
                            {student.guardian_cnic}
                        </h5>
                    </div>
                </div>
            </div>

            <br />
            {/* Address */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '12px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>پتا کی معلومات</h2>

                    <div
                        className='flex alignCenter pointer'
                        onClick={() => setEditAddressDetails(true)}
                    >
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>
                <div
                    className='flex  column justifyCenter alignStart w-100'
                    style={{
                        background: '#ffffff',
                        padding: '16px 24px 8px',
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div className='flex alignCenter'>
                        <h2 style={{ color: '#000000' }}>مستقل پتا : </h2>
                        <h3 style={{ color: '#000000', marginRight: 16 }}>
                            {student.permanent_address} {`،`} {student.permanent_city} {`،`}
                            {student.permanent_state}
                        </h3>
                    </div>

                    <div className='flex alignCenter' style={{ marginTop: 12 }}>
                        <h2 style={{ color: '#000000' }}>موجودہ پتا: </h2>
                        <h3 style={{ color: '#000000', marginRight: 16 }}>
                            {student.current_address} {`،`} {student.current_city} {`،`}
                            {student.current_state}
                        </h3>
                    </div>
                </div>
            </div>

            <br />
            {/* Education */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '18px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>تعلیم سے متعلق معلومات</h2>

                    <div
                        className='flex alignCenter pointer'
                        onClick={() => setEditEducationDetails(true)}
                    >
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#ffffff',
                        padding: '16px 24px 8px',
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div className='flex column justifyCenter alignStart'>
                        <div className='flex alignCenter'>
                            <h3 style={{ color: '#000000', minWidth: 100 }}>سابقہ دینی تعلیم : </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>
                                {student.current_religious_education}
                            </h3>
                        </div>

                        <div className='flex alignCenter' style={{ marginTop: 16 }}>
                            <h3 style={{ color: '#000000', minWidth: 100 }}>سابقہ عصرک تعلیم: </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>
                                
                                {student.current_modern_education}
                            </h3>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 16 }}>
                            <h3 style={{ color: '#000000', minWidth: 100 }}>سابقہ تعلیمی مرکز: </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>
                                {student.former_religious_education_institute}
                            </h3>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 16 }}>
                            <h3 style={{ color: '#000000', minWidth: 100 }}>
                                سابقہ تعلیمی مرکز چھوڑنے کی وجہ:
                            </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>
                                {student.reason_for_leaving_former_religious_institute}
                            </h3>
                        </div>
                    </div>

                    <div
                        style={{
                            background: '#42424294',
                            height: '100%',
                            width: 2,
                            margin: '0 8px',
                        }}
                    />
                    <div className='flex column' style={{ maxWidth: 520 }}>
                        <div
                            className='flex justifyBetween alignCenter'
                            style={{
                                background: '#ECFAF6',
                                borderRadius: 4,
                                marginTop: 8,
                                border: '1px solid #058464',
                                minWidth: 300,
                                padding: '16px 16px 12px',
                            }}
                        >
                            <div className='flex column justifyStart alignStart'>
                                <h3 style={{ color: '#000000' }}>شعبہ ۔ کلاس </h3>
                                <h4 style={{ color: '#000000' }}>
                                    {student.class_room.department_urdu_name}
                                    <span style={{ margin: '0 8px' }}> -</span>
                                    {student.class_room.name}
                                </h4>
                            </div>

                            <div
                                style={{
                                    background: '#42424294',
                                    height: 48,
                                    width: 2,
                                    margin: '0 8px',
                                }}
                            />
                            <div className='flex column justifyStart alignStart'>
                                <h3 style={{ color: '#000000' }}>داخلہ کی کیفیت </h3>
                                <h4 style={{ color: '#000000' }}>{student.residency}</h4>
                            </div>
                        </div>
                        <div
                            className='flex justifyBetween alignCenter'
                            style={{
                                background: '#ECFAF6',
                                borderRadius: 4,
                                marginTop: 8,
                                border: '1px solid #058464',
                                minWidth: 300,
                                padding: '16px 16px 12px',
                            }}
                        >
                            <div className='flex column justifyStart alignStart'>
                                <h3 style={{ color: '#000000', borderBottom: '2.5px solid' }}>
                                    {`مضامین :${student.class_room.name}`}
                                </h3>
                                <div
                                    className='flex alignStart w-100'
                                    style={{ marginTop: 16, flexWrap: 'wrap' }}
                                >
                                    {student['subjects'] && student['subjects'].length > 0 ? (
                                        student['subjects'].map((subject, index) => (
                                            <h4 style={{ color: '#000000' }} key={index + 1}>
                                                {(index !== 0 ||
                                                    index + 1 !== student['subjects'].length) && (
                                                    <span
                                                        style={{ margin: '0 8px 0 2px' }}
                                                    >{`  -  `}</span>
                                                )}
                                                {subject['name']}
                                            </h4>
                                        ))
                                    ) : (
                                        <h4 style={{ color: '#000000' }}>
                                            ابھی مضامین سسٹم میں شامل نہیں کیے گئے
                                        </h4>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            {/* Guardian Information */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '12px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>سرپرست کی معلومات</h2>

                    <div
                        className='flex alignCenter pointer'
                        onClick={() => setEditGuardianDetails(true)}
                    >
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>

                <div
                    className='flex justifyBetween alignStart w-100'
                    style={{
                        background: '#ffffff',
                        padding: '12px 24px 6px',
                        minHeight: 120,
                    }}
                >
                    <div className='flex justifyStart'>
                        <div
                            className='flex'
                            style={{ position: 'relative' }}
                            onMouseEnter={() => setOnImageHover(true)}
                            onMouseLeave={() => setOnImageHover(false)}
                        >
                            <img
                                src={student.guardian_image_url}
                                alt='profile_image'
                                height={96}
                                width={96}
                                style={{ borderRadius: '50%', border: '1px solid #757575' }}
                            />
                            {onImageHover && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        width: 96,
                                        height: 96,
                                        background: '#00000075',
                                        borderRadius: '50%',
                                    }}
                                >
                                    <div
                                        className='flex justifyCenter alignCenter pointer h-100'
                                        onClick={() => setEditPersonalImage(true)}
                                    >
                                        <img
                                            src={EditIcon}
                                            alt='edit_icon'
                                            height={24}
                                            width={24}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='flex column' style={{ marginRight: 16 }}>
                            <div className='flex alignCenter' style={{ marginTop: 8 }}>
                                <h2 style={{ color: '#000000' }}> {student.guardian_name}</h2>
                            </div>

                            <div className='flex alignCenter' style={{ marginTop: 4 }}>
                                <div className='flex alignCenter'>
                                    <div className='flex alignCenter'>
                                        <h4 style={{ color: '#000000', marginLeft: 10 }}>
                                            شناختی کارڈ نمبر:
                                        </h4>
                                        <img
                                            src={AccountIcon}
                                            alt='شناختی کارڈ نمبر'
                                            height={16}
                                            width={16}
                                            style={{ objectFit: 'contain' }}
                                        />
                                        <h5
                                            style={{
                                                color: '#000000',
                                                marginRight: 12,
                                                fontFamily: 'CircularStd',
                                            }}
                                        >
                                            {student.guardian_cnic}
                                        </h5>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        background: '#42424294',
                                        height: 16,
                                        width: 2,
                                        margin: '0 8px',
                                    }}
                                />

                                <div className='flex alignCenter'>
                                    <h3 style={{ color: '#000000' }}>رشتہ : </h3>
                                    <h3 style={{ color: '#000000', marginRight: 12 }}>
                                        {student.relation_with_guardian}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className='flex column'
                        style={{
                            background: '#ECFAF6',
                            borderRadius: 4,
                            marginTop: 8,
                            border: '1px solid #058464',
                            minWidth: 300,
                            padding: '12px 16px 10px',
                        }}
                    >
                        <h3 style={{ color: '#000000' }}>رابطے کی معلومات </h3>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <div className='flex alignCenter'>
                                <img
                                    src={WhatsappIcon}
                                    alt='موبائل نمبر'
                                    height={16}
                                    width={16}
                                    style={{ objectFit: 'contain' }}
                                />
                                <h5
                                    style={{
                                        color: '#000000',
                                        marginRight: 12,
                                        fontFamily: 'CircularStd',
                                    }}
                                >
                                    {student.guardian_primary_phone_number}
                                </h5>
                            </div>
                            {student.guardian_secondary_phone_number && (
                                <div
                                    style={{
                                        background: '#42424294',
                                        height: 16,
                                        width: 2,
                                        margin: '0 8px',
                                    }}
                                />
                            )}
                            {student.guardian_secondary_phone_number && (
                                <div className='flex alignCenter'>
                                    <img
                                        src={PhoneIcon}
                                        alt='موبائل نمبر'
                                        height={16}
                                        width={16}
                                        style={{ objectFit: 'contain' }}
                                    />
                                    <h5
                                        style={{
                                            color: '#000000',
                                            marginRight: 8,
                                            fontFamily: 'CircularStd',
                                        }}
                                    >
                                        {student.secondary_phone_number}
                                    </h5>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#eeeded',
                        padding: '14px 24px 6px',
                        borderTop: '1px solid #757575',
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div className='flex alignCenter'>
                        <h3 style={{ color: '#757575' }}>سرپرست کے والد کا نام: </h3>
                        <h3 style={{ color: '#757575', marginRight: 12 }}>
                            {student.guardian_father_name}
                        </h3>
                    </div>
                </div>
            </div>

            <br />
            {/* Card Information */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '18px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>کارڈ سے متعلق معلومات</h2>

                    <div
                        className='flex alignCenter pointer'
                        onClick={() => setEditCardDetails(true)}
                    >
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>
                <div
                    className='flex justifyBetween alignStart w-100'
                    style={{
                        background: '#ffffff',
                        padding: 24,
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div
                        className='flex column justifyEnd alignStart'
                        style={{ direction: 'ltr', width: 400 }}
                    >
                        <div className='flex column alignStart' style={{ marginTop: 8 }}>
                            <h4
                                style={{
                                    color: '#000000',
                                    minWidth: 160,
                                    fontFamily: 'CircularStd',
                                }}
                            >
                                Address:
                            </h4>
                            <p style={{ color: '#000000', fontFamily: 'CircularStd' }}>
                                {student.address_for_card}
                            </p>
                        </div>
                    </div>

                    <div
                        style={{
                            background: '#42424294',
                            height: '100%',
                            width: 2,
                        }}
                    />

                    <div
                        className='flex column justifyCenter alignStart'
                        style={{ direction: 'ltr' }}
                    >
                        <div className='flex alignCenter'>
                            <h4
                                style={{
                                    color: '#000000',
                                    minWidth: 160,
                                    fontFamily: 'CircularStd',
                                }}
                            >
                                Name :
                            </h4>
                            <p style={{ color: '#000000', fontFamily: 'CircularStd' }}>
                                {student.name_for_card}
                            </p>
                        </div>

                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h4
                                style={{
                                    color: '#000000',
                                    minWidth: 160,
                                    fontFamily: 'CircularStd',
                                }}
                            >
                                Degree Program:
                            </h4>
                            <p style={{ color: '#000000', fontFamily: 'CircularStd' }}>
                                
                                {student.department_for_card}
                            </p>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h4
                                style={{
                                    color: '#000000',
                                    minWidth: 160,
                                    fontFamily: 'CircularStd',
                                }}
                            >
                                Class:
                            </h4>
                            <p style={{ color: '#000000', fontFamily: 'CircularStd' }}>
                                {student.section_for_card}
                            </p>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h4
                                style={{
                                    color: '#000000',
                                    minWidth: 160,
                                    fontFamily: 'CircularStd',
                                }}
                            >
                                Hostilite:
                            </h4>
                            <p style={{ color: '#000000', fontFamily: 'CircularStd' }}>
                                {student.is_from_hostel_status_for_card ? 'Yes' : 'No'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Update Profile Image */}
            {edit_profile_image && (
                <ProfileImage
                    data={student}
                    isStudent={true}
                    open={edit_profile_image}
                    setState={setStudent}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditPersonalImage(false)}
                />
            )}
            {/* Update Guardian Image */}
            {edit_guardian_image && (
                <GuardianImage
                    data={student}
                    isStudent={true}
                    setState={setStudent}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditGuardianImage(false)}
                />
            )}
            {/* Edit Personal Details */}
            {edit_personal_details && (
                <EditPersonalDetails
                    data={student}
                    isStudent={true}
                    setState={setStudent}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditPersonalDetails(false)}
                />
            )}
            {/* Edit Addresss Details */}
            {edit_address_details && (
                <AddressDetails
                    data={student}
                    isStudent={true}
                    setState={setStudent}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditAddressDetails(false)}
                />
            )}
            {/* Education Details */}
            {edit_education_details && (
                <EducationDetails
                    data={student}
                    isStudent={true}
                    setState={setStudent}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditEducationDetails(false)}
                />
            )}
            {/* Guardian Details */}
            {edit_guardian_details && (
                <GuardianDetails
                    data={student}
                    isStudent={true}
                    setState={setStudent}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditGuardianDetails(false)}
                />
            )}
            {/* Card Details */}
            {edit_card_details && (
                <CardDetails
                    data={student}
                    isStudent={true}
                    setState={setStudent}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditCardDetails(false)}
                />
            )}
        </div>
    );
};

export default StudentDetails;
